//libary
import React, { Component } from 'react';

class Footer extends Component {
    
    render() {
        return <footer className="footerBlock">
            <div className="footerBlock2">
                <span className="footerText">鉅亨證券投資顧問股份有限公司</span>
                <span className="footerText">113金管投顧新字003號</span>
                <span className="footerText">公司地址：台北市信義區松仁路89號18樓B室</span>
                <span className="footerText">服務專線： (02)2720-8126</span>
                <span className="footerText">客服信箱： cs@anuefund.com.tw</span>
                <span className="footerText">服務時間：09:00-17:00</span>
            </div>
            <div className="footerBlock2">
                <span className="footerText">鉅亨投顧獨立經營管理 │ 版權為鉅亨投顧所有</span>
                <a rel="noopener noreferrer" target="_blank" href="https://www.anuefund.com/Sitemap.aspx" className="footerText2">網站導覽</a>
                <span className="footerText2"> │ </span>
                <a rel="noopener noreferrer" target="_blank" className="footerText2" href="https://m.anuefund.com/Guide/Contact">聯絡我們</a>
                <span className="footerText2"> │ </span>
                <a rel="noopener noreferrer" href="https://www.anuefund.com/Privacy.aspx" target="_blank" className="footerText2">隱私權說明</a>
                <span className="footerText2"> │ </span>
                <a rel="noopener noreferrer" href="https://www.foi.org.tw/index.html" target="_blank" className="footerText2">金融消費評議中心</a>
                
                <a rel="noopener noreferrer" href="https://www.amlo.moj.gov.tw/" target="_blank" className="footerText">行政院洗錢防制辦公室</a>
            </div>
        </footer>
    }
}
export default Footer;